import React from 'react';
import { Box, Container, Typography, Stack, Link } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { brand, siteLogoUrlOnDark } from '../theme';

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <Box
      component="footer"
      sx={{
        mt: 10,
        bgcolor: brand.navy,
        color: '#CBD5E1',
        py: { xs: 6, md: 8 },
      }}
    >
      <Container maxWidth="lg">
        <Stack
          direction={{ xs: 'column', md: 'row' }}
          spacing={6}
          justifyContent="space-between"
        >
          <Stack direction="row" spacing={2.5} alignItems="center" sx={{ maxWidth: 420 }}>
            <Box
              component="img"
              src={siteLogoUrlOnDark}
              alt="G&R Nexus"
              sx={{ height: 40, width: 'auto', maxWidth: 200, objectFit: 'contain' }}
            />
            <Box>
              <Typography variant="h5" sx={{ color: '#fff', fontWeight: 800, lineHeight: 1.1 }}>
                G&amp;R Nexus
              </Typography>
              <Typography variant="body2" sx={{ color: '#94A3B8', mt: 0.5 }}>
                Custom Software. Intelligent Solutions.
              </Typography>
            </Box>
          </Stack>

          <Stack direction={{ xs: 'column', sm: 'row' }} spacing={{ xs: 4, sm: 6 }}>
            <FooterCol title="Product">
              <FooterLink to="/concierge">Concierge</FooterLink>
              <FooterLink to="/concierge#features">Features</FooterLink>
            </FooterCol>
            <FooterCol title="Company">
              <FooterLink to="/about">About Nexus</FooterLink>
              <FooterLink to="/contact">Contact</FooterLink>
            </FooterCol>
            <FooterCol title="Get in touch">
              <Link
                href="mailto:craig@gnrnexus.com"
                underline="hover"
                sx={{ color: '#CBD5E1', '&:hover': { color: brand.blueLight } }}
              >
                craig@gnrnexus.com
              </Link>
            </FooterCol>
          </Stack>
        </Stack>

        <Box
          sx={{
            mt: 6,
            pt: 3,
            borderTop: `1px solid rgba(255,255,255,0.08)`,
          }}
        >
          <Typography variant="body2" sx={{ color: '#64748B' }}>
            © {year} G&amp;R Nexus. All rights reserved.
          </Typography>
        </Box>
      </Container>
    </Box>
  );
}

function FooterCol({ title, children }) {
  return (
    <Stack spacing={1.25} sx={{ minWidth: 140 }}>
      <Typography
        variant="overline"
        sx={{ color: brand.blueLight, letterSpacing: '0.12em', fontWeight: 700 }}
      >
        {title}
      </Typography>
      {children}
    </Stack>
  );
}

function FooterLink({ to, children }) {
  return (
    <Link
      component={RouterLink}
      to={to}
      underline="hover"
      sx={{
        color: '#CBD5E1',
        '&:hover': { color: brand.blueLight },
      }}
    >
      {children}
    </Link>
  );
}
